"use client";
import ResultContent from "@/components/resultContent";
import { FlexCol } from "@/components/ui";

const SAMPLE = {
  iban: "IR120570028080010608100800",
  ibanDisplay: "1205 7002 8080 0106 0810 0800",
  depositNumber: "0105688432001",
  bank: "ملی ایران",
  owner: "علی محمدی",
  status: "فعال",
};

const resultContent = [
  { label: "شماره شبا", value: SAMPLE.iban },
  { label: "نام بانک", value: SAMPLE.bank },
  { label: "وضعیت حساب", value: SAMPLE.status },
  { label: "صاحبان حساب", value: SAMPLE.owner },
];

const AccountToIbanSample = () => {
  return (
    <FlexCol className="items-stretch">
      <div className="mb-5 flex items-center justify-center gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-2 text-xs text-amber-700">
        <span>⚠️</span>
        <span>این نتیجه صرفاً یک نمونه است و اطلاعات واقعی نیست</span>
      </div>

      <div className="mx-auto mb-6 w-full sm:w-3/4">
        <div
          className="relative w-full overflow-hidden rounded-xl px-5 py-5"
          style={{
            background:
              "linear-gradient(135deg, #5a2bd2 0%, #7c3aed 55%, #4338ca 100%)",
          }}
        >
          <div
            className="pointer-events-none absolute -top-8 -left-8 h-32 w-32 rounded-full"
            style={{ background: "rgba(255,255,255,0.1)" }}
          />
          <div
            className="pointer-events-none absolute -right-6 -bottom-6 h-24 w-24 rounded-full"
            style={{ background: "rgba(255,255,255,0.07)" }}
          />

          <div className="relative z-10 mb-3">
            <span className="text-sm font-semibold text-white/90">
              {SAMPLE.bank}
            </span>
          </div>

          <div className="relative z-10 mb-4 flex flex-col items-end">
            <span className="mb-1 text-xs text-white/60">شماره شبا</span>
            <p
              className="text-sm font-bold tracking-wide text-white lg:text-base"
              dir="ltr"
            >
              {SAMPLE.ibanDisplay}
            </p>
          </div>

          <p className="relative z-10 mb-4 text-center text-sm font-semibold text-white">
            {SAMPLE.owner}
          </p>

          <div className="relative z-10 flex justify-between px-1">
            <div className="flex flex-col items-start">
              <span className="text-xs text-white/60">شماره حساب</span>
              <span
                className="text-xs font-semibold text-white sm:text-sm"
                dir="ltr"
              >
                {SAMPLE.depositNumber}
              </span>
            </div>
            <div className="flex flex-col items-end">
              <span className="text-xs text-white/60">وضعیت حساب</span>
              <span className="text-xs font-semibold text-white sm:text-sm">
                {SAMPLE.status}
              </span>
            </div>
          </div>
        </div>
      </div>

      <ResultContent content={resultContent} />
    </FlexCol>
  );
};

export default AccountToIbanSample;
